export const formatErrorFileUploading = (data) => {
  const subjects = {
    image_size: 'En eller flera bilder är för stora för att skicka: ',
    image_type: 'En eller flera bilder har ett otillåtet bildformat: ',
    file_size: 'En eller flera filer är för stora för att skicka: ',
    file_type: 'En eller flera filer har ett otillåtet filformat: ',
    general: 'Tillfälligt fel när en eller flera filer och/eller bilder laddades upp.',
  }
  const descriptions = {
    image_size: 'Bilden får max vara 10 MB.',
    image_type: 'Tillåtna bildformat: png, jpg, jpeg, gif.',
    file_size: 'Filen får max vara 10 MB.',
    file_type: 'Tillåtna filformat: txt, pdf, rtf.',
    general: 'Försök igen senare.',
  }

  const errorObj = data.reduce((errorGroups, error) => {
    const { errorType, target = '' } = error?.reason
    const group = errorGroups.find((g) => g.type === errorType)
    if (group) {
      group.targets.push(` ${target}`)
    } else {
      errorGroups.push({
        type: errorType,
        description: descriptions[errorType],
        subject: subjects[errorType],
        targets: [target],
      })
    }
    return errorGroups
  }, [])

  return {
    error: errorObj,
    errorType: 'multiple_errors_files/images',
  }
}
